import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ProjectCard from "@/components/projects/ProjectCard";
import { FileText, Search, PlusCircle } from "lucide-react";
import { useJobStore } from "@/store/jobStore";
import { useUserStore } from "@/store/userStore";
import { debounce } from "@/lib/utils";
// import { Pagination } from "@/components/ui/pagination-component";

const MyJobs: React.FC = () => {
  const [showArchive, setShowArchive] = useState(false);
  const [fetchDataProps, setFetchDataProps] = useState({
    search: "",
    skills: "",
    category: "",
    budget: "",
    PricingDetails: "",
    sortBy: "createdAt",
    order: "desc",
    page: 1,
    limit: 10,
  });

  const { userJobs, fetchJobProfileById } = useJobStore();
  const { user } = useUserStore();

  const handleSearchTerms = (e) => {
    setFetchDataProps({
      ...fetchDataProps,
      search: e.target.value,
    });
    const payload = {
      search: e.target.value,
      skills: "",
      category: "",
      budget: "",
      PricingDetails: "",
      sortBy: "createdAt",
      order: "desc",
      page: 1,
      limit: 10,
    };
    // fetchAllJobs(payload);
  };
  const debouncedFetchJobs = useCallback(debounce(handleSearchTerms, 500), []);

  useEffect(() => {
    fetchJobProfileById(user?.userId, user?.accessToken);
  }, []);

  const filteredJobs = Array.isArray(userJobs)
    ? userJobs.filter((project) =>
        showArchive
          ? project?.projectvisibility === false
          : project?.projectvisibility === true
      )
    : [];

  return (
    <div className="container mx-auto p-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <div>
          <h1 className="text-3xl font-bold">Jobs</h1>
          <p className="text-muted-foreground">
            Manage and track all your jobs
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={() => setShowArchive((s) => !s)}>
            {showArchive ? "View Active Jobs" : "View Archived"}
          </Button>
          <Link to="/create-job">
            <Button className="bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600">
              <PlusCircle className="mr-2 h-4 w-4" />
              Post New Job
            </Button>
          </Link>
        </div>
      </div>

      {/* Filters and Search */}
      {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search projects..."
            className="pl-8"
            value={searchTerm}
            onChange={(e) => {
              debouncedFetchJobs(e);
              setSearchTerm(e.target.value);
            }}
          />
        </div>

        <Select
          value={fetchDataProps.category}
          onValueChange={(value) => {
            setFetchDataProps({
              ...fetchDataProps,
              category: value === "all" ? "" : value,
              page: 1,
            });
            fetchAllJobs({ ...fetchDataProps, category: value });
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="Category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={"all"}>All</SelectItem>
            {CATEGORIES.map((category, idx) => {
              return (
                <div key={idx}>
                  <SelectItem value={category}>{category}</SelectItem>
                </div>
              );
            })}
          </SelectContent>
        </Select>

        <div>
          <Select
            value={fetchDataProps.skills}
            onValueChange={(value) => {
              setFetchDataProps({
                ...fetchDataProps,
                skills: value === "all" ? "" : value,
                page: 1,
              });
              fetchAllJobs({
                ...fetchDataProps,
                skills: value === "all" ? "" : value,
              });
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Skills" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {Skills.map((skill, idx) => {
                return (
                  <SelectItem key={idx} value={skill}>
                    {skill}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        </div>
      </div> */}

      {filteredJobs && Array.isArray(filteredJobs) && filteredJobs.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredJobs.map((project) => (
            <ProjectCard key={project?._id} project={project} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <FileText className="mx-auto h-12 w-12 text-muted-foreground opacity-50" />
          {/* <h3 className="mt-4 text-lg font-medium">No projects found</h3> */}
          <h3 className="mt-4 text-lg font-medium">
            {showArchive ? "No archived jobs" : "Post your first job"}
          </h3>
          <p className="text-muted-foreground">
            {showArchive
              ? "Switch back to Active Jobs to see current jobs"
              : "Try adjusting your search or filter criteria"}
          </p>
        </div>
      )}

      {/* <Pagination
        totalPages={freelancers.totalPages}
        onPageChange={handlePageChange}
        // initialPage={fetchDataProps?.page}
        forcePage={(fetchDataProps.page || 1) - 1}
        className="mt-6"
      /> */}
    </div>
  );
};

export default MyJobs;
